import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import AppBarCustom from "../shared/components/AppBarCustom";
import DrawerCustom from "../shared/components/DrawerCustom";
import DrawerCustomDesktop from "../shared/components/DrawerCustomDesktop";
import "./account.css";
import { isMobile } from "react-device-detect";
import AppBarPortal from "../shared/components/AppBarPortal";
import { compose } from "redux";
import { connect } from "react-redux";
import {
  onSocketMessage,
  onSocketSendToken
} from "../../redux/actions/notificationActions";

const styles = theme => ({
  root: {
    flexGrow: 1
  }
});

class Account extends React.PureComponent {
  componentDidMount() {
    let { auth, onSocketSendToken, ws, onSocketMessage } = this.props;
    if (auth.is_authenticated && auth.token && ws.readyState === 1) {
      onSocketSendToken();
      ws.onmessage = function(event) {
        onSocketMessage({ notification: JSON.parse(event.data) });
      };
    }
  }

  render() {
    const { classes } = this.props;
    const isNotMedicalInfo =
      this.props.location.pathname.search("medical-information") === -1;

    return (
      <div className={classes.root}>
        {isNotMedicalInfo && isMobile && (
          <React.Fragment>
            <AppBarCustom />
            <DrawerCustom />
          </React.Fragment>
        )}

        {!isMobile && isNotMedicalInfo && <AppBarPortal />}
        {!isMobile && isNotMedicalInfo && <DrawerCustomDesktop />}

        <React.Fragment>
          <div>{this.props.children}</div>
        </React.Fragment>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  ws: state.notification.ws || null
});

const enhance = compose(
  withRouter,
  withStyles(styles),
  connect(
    mapStateToProps,
    { onSocketSendToken, onSocketMessage }
  )
);

export default enhance(Account);



// WEBPACK FOOTER //
// ./src/modules/account/Account.js